var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.989586 12.3032C0.794324 12.4984 0.794324 12.815 0.989586 13.0103C1.18485 13.2055 1.50143 13.2055 1.69669 13.0103L6.99988 7.70709L12.3033 13.0105C12.4986 13.2058 12.8151 13.2058 13.0104 13.0105C13.2057 12.8152 13.2057 12.4987 13.0104 12.3034L7.70698 6.99999L13.0104 1.69657C13.2057 1.50131 13.2057 1.18473 13.0104 0.989464C12.8151 0.794202 12.4986 0.794202 12.3033 0.989465L6.99988 6.29288L1.69669 0.989696C1.50143 0.794433 1.18485 0.794433 0.989586 0.989696C0.794324 1.18496 0.794324 1.50154 0.989586 1.6968L6.29277 6.99999L0.989586 12.3032Z",
    fill: "#24292F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8b32344282982cb81f11f9d7c4208c94.svg";
export { ForwardRef as ReactComponent };